// Password validation function
export const validatePassword = (password) => {
  const errors = [];

  if (password.length < 8) errors.push("at least 8 characters");
  if (!/[A-Z]/.test(password)) errors.push("one uppercase letter");
  if (!/[a-z]/.test(password)) errors.push("one lowercase letter");
  if (!/[0-9]/.test(password)) errors.push("one number");
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password))
    errors.push("one special character");

  return errors.length > 0
    ? `Password must include: ${errors.join(", ")}.`
    : null;
};

// Email validation function
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email) ? null : "Invalid email format";
};

// Function to handle singular/plural text
export const pluralize = (count, singular, plural) => {
  return count === 1 ? singular : plural;
};

export function addDays(dateLike, days) {
  const d = dateLike instanceof Date ? dateLike : new Date(dateLike);

  if (Number.isNaN(d.getTime())) {
    return null;
  }

  d.setDate(d.getDate() + days);
  // return "YYYY-MM-DD"
  return d.toISOString().slice(0, 10);
}
